import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Grid from "../../common/layout/grid";
import { setModoTela } from "../geracaoLeituraActions";

export function AbasGraficosDiaMesAnoComponent(props) {
    if (!["graficoEnergiaDia", "graficoEnergiaDiasMes", "graficoEnergiaMesesAno"].includes(props.modoTela)) return null;
    return (
        <div
            style={{
                display: "flex",
                flexWrap: "no-wrap",
                width: "100%",
                paddingTop: 15,
                marginBottom: -1,
                boxShadow: "inset 0 0 2px #ddd",
                backgroundColor: "##fff",
            }}
        >
            <Grid
                cols="4 4 4 4"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: props.modoTela === "graficoEnergiaDia" ? "#fff" : "#f5f5f5",
                    cursor: "pointer",
                    boxShadow: props.modoTela === "graficoEnergiaDia" ? "inset 0 2px 2px 1px #e7e7e7" : "#e9e4e4 0px 2px 5px 1px inset",
                    marginTop: props.modoTela === "graficoEnergiaDia" ? -4 : null,
                    borderRadius: "15px 15px 0 0",
                    borderBottom: `1px solid ${props.modoTela === "graficoEnergiaDia" ? "#fff" : "#ddd"} `,
                    paddingBlock: 8,
                }}
                title="Ver o gráfico do dia"
                onClick={() => {
                    props.setModoTela("graficoEnergiaDia", props.registro);
                }}
            >
                <span style={{ fontSize: "0.9rem" }}>Dia</span>
            </Grid>

            <Grid
                cols="4 4 4 4"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: props.modoTela === "graficoEnergiaDiasMes" ? "#fff" : "#f5f5f5",
                    cursor: "pointer",
                    boxShadow: props.modoTela === "graficoEnergiaDiasMes" ? "inset 0 2px 2px 1px #e7e7e7" : "#e9e4e4 0px 2px 5px 1px inset",
                    marginTop: props.modoTela === "graficoEnergiaDiasMes" ? -4 : null,
                    borderRadius: "15px 15px 0 0",
                    borderBottom: `1px solid ${props.modoTela === "graficoEnergiaDiasMes" ? "#fff" : "#ddd"} `,
                    paddingBlock: 8,
                }}
                title="Ver o gráfico do mês"
                onClick={() => {
                    props.setModoTela("graficoEnergiaDiasMes", props.registro);
                }}
            >
                <span style={{ fontSize: "0.9rem" }}>Mês</span>
            </Grid>

            <Grid
                cols="4 4 4 4"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: props.modoTela === "graficoEnergiaMesesAno" ? "#fff" : "#f5f5f5",
                    cursor: "pointer",
                    boxShadow: props.modoTela === "graficoEnergiaMesesAno" ? "inset 0 2px 2px 1px #e7e7e7" : "#e9e4e4 0px 2px 5px 1px inset",
                    marginTop: props.modoTela === "graficoEnergiaMesesAno" ? -4 : null,
                    borderRadius: "15px 15px 0 0",
                    borderBottom: `1px solid ${props.modoTela === "graficoEnergiaMesesAno" ? "#fff" : "#ddd"} `,
                    paddingBlock: 8,
                }}
                title="Ver o gráfico do ano"
                onClick={() => {
                    props.setModoTela("graficoEnergiaMesesAno", props.registro);
                }}
            >
                <span style={{ fontSize: "0.9rem" }}>Ano</span>
            </Grid>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        modoTela: state.geracaoLeitura.modoTela,
        registro: state.geracaoLeitura.registro,
    };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({ setModoTela }, dispatch);
export const AbasGraficosDiaMesAno = connect(mapStateToProps, mapDispatchToProps)(AbasGraficosDiaMesAnoComponent);
